module.exports = __webpack_public_path__ + "static/media/icon-menu-summary-active.fa33438f.svg";